import {
  AssistantOutcomeFragment,
  ConversationsV2ChatState,
} from '@spotify/confidence-graphql';

export type ChatStatus =
  | 'idle'
  | 'running'
  | 'attention'
  | 'completed'
  | 'error';

export const getChatStatus = (
  state?: ConversationsV2ChatState | null,
  assistantOutcome?: AssistantOutcomeFragment | null,
): ChatStatus => {
  if (assistantOutcome?.error) return 'error';
  if (assistantOutcome?.toolConfirmation || assistantOutcome?.askQuestion) {
    return 'attention';
  }
  if (state === ConversationsV2ChatState.Running) return 'running';
  if (assistantOutcome?.outcome) return 'completed';
  return 'idle';
};

export const CHAT_STATUS_LABELS: Record<ChatStatus, string> = {
  idle: 'No activity',
  running: 'Running',
  attention: 'Needs attention',
  completed: 'Completed',
  error: 'Error',
};
